/* eslint-disable-next-line primer-react/no-deprecated-flash -- Existing Flash usage should be migrated to Banner. */
import {Flash} from '@primer/react'
import {InfoIcon} from '@primer/octicons-react'
import {getPushRulesetTargetInfo} from '../../helpers/utils'

export const PushRuleTargetingBanner = ({publicPushRulesets}: {publicPushRulesets: boolean}) => {
  return (
    <Flash>
      <div className="d-flex flex-row flex-items-center">
        <InfoIcon />
        <span>{getPushRulesetTargetInfo(publicPushRulesets)}</span>
      </div>
    </Flash>
  )
}
